import React, { useState } from "react";
import LoginForm from "./Login-comp";
import "./styles/Login.css";

const Login = () => {
	const [frmLoad, setFrmLoad] = useState("login");

	const formSwitcher = frmType => {
		setFrmLoad(frmType);
	};

	return (
		<div className="login-page">
			<div className="jumbotron form-box">
				{frmLoad === "login" && <LoginForm formSwitcher={formSwitcher} />}
			</div>
		</div>
	);
};

export default Login;